/**
 * The Authorization header key
 */
export const Authorization = 'Authorization';
